import { PropsWithChildren } from "react";
import { Pluarlise } from "./Pluarlise";

export type CardProps = {
    errors: string[]
}

export function ErrorsDisplay(props: PropsWithChildren<CardProps>) {
    return (
        <>
            {props.errors.length > 0 && <div className="alert alert-danger align-content-center" aria-label="Validation errors">
                Please fix the validation {Pluarlise("error", props.errors.length)}:
                <ul className="mb-0">
                    {props.errors.map(x => { return <li aria-label={`Validation error:${x}`} key={x}>{x}</li> })}
                </ul>
                {props.children}
            </div>}
        </>
    );
}